import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';

import css from './AboutPage.module.css';
import image from './about-us-1056.jpg';

import bridget from './Bridget-Conway-Taylor.jpg';
import sky from './Sky-Davis.jpg';
import marisa from './Marisa-Hall.jpg';
import gala from './Gala-Mukomolova.jpg';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Queer Healers',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Meet Queer Healers</h1>
          <img className={css.coverImage} src={image} alt="My first ice cream." />

          <div className={css.contentWrapper}>

            {/* <div className={css.contentSide}> */}
              {/* <p className={css.contentSide}>We’re queer people who want to work with queer practioners.</p> */}
            {/* </div> */}

{/* 
            <div className={css.contentMain}>
              <h2>Why We’re Here</h2>

              <p>
              We know how painful and infuriating it can be to seek care in a world that denies queer people their humanity. Especially queer people who are trans. Especially queer people who are Black. It keeps a lot of us from getting the support we need.
              </p>

              <p>
                Queer people need an easy way to find healers who relate to their lived-experience. And queer practitioners need a streamlined way to support themselves that doesn’t involve becoming a digital marketing maven.
              </p>

              <p>
               Queer people need an easy way to find practitioners who relate to their lived-experience. And, queer practitioners need a streamlined way to support themselves that doesn’t involve becoming a digital marketing expert. From targetted transphobic legislation, to the legalized loss of bodily autonomy, to the ravages of climate change, queer healers’ livelihoods are at risk. In spite of this, all over the world, our practitioners nurture powerful practices that deserve to thrive. We built Queer Healers in response to these exigencies, by and for the people who need it most.
              </p>
            </div> */}
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
         <h1 className={css.pagesubTitle}>We’re queer people who want to work with queer practioners.</h1>

              <div className={css.contentMain}>
              <h2>Why We’re Here</h2>

              <p>
              We know how painful and infuriating it can be to seek care in a world that denies queer people their humanity. Especially queer people who are trans. Especially queer people who are Black. It keeps a lot of us from getting the support we need.
              </p>

              <p>
              Queer people need an easy way to find practitioners who relate to their lived-experience. And, queer practitioners need a streamlined way to support themselves that doesn’t involve becoming a digital marketing expert. 
              </p>

              <p>
              From targetted transphobic legislation, to the legalized loss of bodily autonomy, to the ravages of climate change, queer healers’ livelihoods are at risk. In spite of this, all over the world, our practitioners nurture powerful practices that deserve to thrive. We built Queer Healers in response to these exigencies, by and for the people who need it most.
              </p>
            </div>
              <h2>

                  Our Founders
                </h2>
                <div className={css.teamMembers}>
                  <div className={css.teamMember}>
                    <div className="col"> 
                      <img src={bridget} alt="Team member image" />
                      <h3>Bridget Conway-Taylor</h3>
                      <p>Bridget is a global strategy and operations leader who has launched 400+ digital products and marketing campaigns. She is also a co-leader of <a href="https://www.instagram.com/kinkoutevents">Kink Out</a>, frequent collaborator with <a href="https://www.redcanarysong.net">Red Canary Song</a>, and facilitator of the <a href="https://www.grapevine.org/giving-circle/PdWhoa/Black-Trans-Lives-Thrive">Black Trans Lives Thrive Giving Circle</a>.</p>
                    </div>
                  </div>
                  <div className={css.teamMember}>
                    <div className="col">
                      <img src={sky} alt="Team member image" />
                      <h3>Sky Davis</h3>
                      <p>Sky is a product design engineer at AngelList, AI enthusiast, and fintech specialist, thanks to stints with global institutions.</p>
                    </div>
                  </div>
                  <div className={css.teamMember}>
                    <div className="col">
                      <img src={marisa} alt="Team member image" />
                      <h3>Marisa Hall</h3>
                      <p>Marisa is a writer, movement facilitator, and community herbalist, who's worked across InfoSec, HR, L&D, and Engineering at Etsy.</p>
                    </div>
                  </div>
                  <div className={css.teamMember}>
                    <div className="col">
                      <img src={gala} alt="Team member image" />
                      <h3>Gala Mukomolova</h3>
                      <p>Gala is a Moscow-born, Brooklyn-raised, <a href="http://galacticrabbit.com">poet and essayist</a>. She has held residencies as house astrologer at <a href="https://www.refinery29.com/en-us/author/gala-mukomolova">Refinery29</a>, <a href="https://www.nylon.com/profile/gala-mukomolova-21824734">Nylon</a>, and <a href="https://hellogiggles.com/originals/galactic-guidance-a-zodiac-advice-column/">HelloGiggles</a>. Currently, she co-hosts <a href="https://anchor.fm/bigdykeenergy/support">Big Dyke Energy</a>, reads Tarot cards, and moonlights as an astrological medium.</p>
                    </div>
                  </div>
                </div>


                <h2>Our Commitments to Community</h2>
                <p><strong>
                Our Goal
                  </strong></p>
                  <p>Queer Healers strives to create a safe, accessible, and generative platform where queer healing practitioners and clients who seek affirming care can find one another.
</p>
<p>Queer Healers is 100% owned by people that come from the communities it serves. We will never sell your data and encourage you to take a look at our <NamedLink name="PrivacyPolicyPage" >Privacy Page</NamedLink> if you have questions about how your information is stored and managed.</p>
                
                <p><strong>Access</strong></p>
              <p>Queer Healers was founded, and is growing, with accessibility in mind. While we always have more work to do, this platform aims to reduce barriers to care and to make it easy to find accessible healing without relying on social media and word of mouth. Practitioners are required to provide accessibility notes for their offerings (e.g. “live subtitles on Zoom”, “ADA-compliant building”, “outdoor in-person sessions available by request”), and we encourage clients to name specific needs they have that may not have been proactively addressed when submitting a booking request.</p>
              <p>Our commitment to site accessibility and usability remains a work in progress and we are always open to feedback! Please send suggestions via our help tool.</p>

                <p><strong>Age Requirements</strong></p>
                <p>To legally safeguard our users as much as possible, we require that all parties involved in a booking be at least 18 years of age. That means practitioners must be at least 18 to be listed on Queer Healers, and everyone must be at least 18 to sign up for a general user account.
</p>

                <p><strong>Zero-tolerance Policy</strong></p>
                <p>Queer Healers prioritizes the safety of queer, trans, Black, Indigenous, people of color (QTBIPOC), disabled, femme, low-income, survivors, and all other oppressed people over the comfort of those in privileged positions. (Anti-racist Education Working Group)
</p>
                <p>Queer Healers also prioritizes the safety and well-being of our team, including the founders, staff, independent contractors, and vendors supporting us in operating the platform.
</p>
            <p>All forms of digital and physical harassment - including threats, offensive comments, stalking, and unwelcome sexual attention - are unacceptable within our community. Likewise, all forms of hateful, bigoted, and/or harmful speech are unacceptable on our platform. This includes interactions within our client-practitioner messaging system, our customer support system, and in any verbal or written communication between platform users and Queer Healers representatives.</p>
                <p>Any reports made via our reporting tool and found to be accurate will result in the offending person’s immediate dismissal from our platform, and may result in further accountability and/or legal action.</p>
                
                
                <p><strong>Practitioner Commitments</strong></p>
                <p>All of our practitioners have acknowledged that their practices are in line with the statements made above, and further, have acknowledged that:
</p>

              <ul>
                <li style={{'listStyleType':'circle'}} >
                  Queer Healers is not liable for any harm or damages incurred as a result of listing themselves on this platform, nor before, during, or after a booking takes place. Please note: practitioners on our platform often have their own liability or consent waivers that must be signed by clients ahead of their session. Queer Healers is not party to such waivers.

                </li>
                <li style={{'listStyleType':'circle'}}>
                  They have been truthful and transparent about their services (i.e. they will not list services they aren’t prepared to provide)

                </li>
                <li style={{'listStyleType':'circle'}}>
                  They will not offer nor accept payment for services outside of the list of modalities available on Queer Healers

                </li>
                <li style={{'listStyleType':'circle'}}>
                  They will not use the on-platform messaging system to spam clients with offers nor ads for future services

                </li>
                <li style={{'listStyleType':'circle'}}>
                  They will not disclose names, identities, or any other information the client sends them through the on-platform messaging system, without permission

                </li>
                <li style={{'listStyleType':'circle'}}>
                  They will not run contests, raffles, or promotions on Queer Healers

                </li>
                <li style={{'listStyleType':'circle'}}>
                  They will not solicit nor manufacture fake reviews on their own profiles, nor manufacture defamatory reviews on the profiles of other practitioners

                </li>
              </ul>

                {/* <h3 className={css.subtitle}>Are you a healer?</h3> */}

                {/* <h3 id="contact" className={css.subtitle}>
                  <a href="/signup">Join Our Directory</a>
                </h3> */}
              </div>
            </div>


          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
